import { Component, OnDestroy, OnInit } from '@angular/core';
import { WindowRef } from '@progress/kendo-angular-dialog';
import { filter } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { FreeServicesRequestListGridDataService } from '../free-services-request-list-grid/free-services-request-list-grid-data.service';
import { takeWhile } from 'rxjs/operators';

@Component({
  selector: 'free-services-parcels',
  templateUrl: './fsp-parcels.component.html',
  standalone: false,
})
export class FspParcelsComponent implements OnInit, OnDestroy {
  private isAlive = true;
  windowRef: WindowRef;
  constructor(
    private translateService: TranslateService,
    public freeServicesRequestListGridDataService: FreeServicesRequestListGridDataService,
  ) {}

  ngOnInit(): void {
    this.handleRequestListGridSelected();
  }

  private updateWindowTitle(caseNumber: string): void {
    this.translateService
      .get('FREE_PORTAL_SERVICES.PARCELS_FOR_REQUEST', {
        signature: caseNumber,
      })
      .pipe(takeWhile(() => this.isAlive))
      .subscribe((title) => {
        this.windowRef.window.instance.title = title;
      });
  }

  handleRequestListGridSelected(): void {
    this.freeServicesRequestListGridDataService.$selection
      .pipe(
        takeWhile(() => this.isAlive),
        filter(Boolean),
      )
      .subscribe((selection) => {
        this.updateWindowTitle(selection.selectedItems[0]?.Numer);
      });
  }

  ngOnDestroy(): void {
    this.isAlive = false;
  }
}
